import React, { Component } from 'react';
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import moment from 'moment';
import axios from 'axios';
import $ from 'jquery';
import { lang } from '../Helpers/lang';
import Header from '../Layouts/Header';
import {apiUrl ,tapURL,cmsURL,mediaUrl } from "../Config/Config";


import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";

import MenuSidebar from '../Layouts/MenuSidebar';
import { baseUrl } from '../Config/Config';

class List extends Component {
  
  constructor(props)
  {
     super(props); 
     this.inputRef = React.createRef();
      this.state = {
          specialties:'',
          activePage: 1,
          totalRecord: '',
          search_all:'',
          selectedStatus:'',
          selectid:'',
          data_status:'',
          bt_data: [],
          selectstatusid:'',
          jsoniconslist: [],
          expandedCategories: {}, 
          editMode: false,
          editedName: '',
          editItemId: null,
          total_files_count:"",
          cat_title:"",
         
      };
      
    
      this.handleInputChange = this.handleInputChange.bind(this);
      this.handleFormSubmit = this.handleFormSubmit.bind(this);
      this.handleNameClick = this.handleNameClick.bind(this);
      this.handleNameChange = this.handleNameChange.bind(this);
      this.handleSaveName = this.handleSaveName.bind(this);
     
    }

   
   componentDidMount() {
    this.listloadData()
   }
   componentDidUpdate(prevProps, prevState) {
    if (this.state.editMode && this.state.editItemId !== prevState.editItemId) {
      this.inputRef.focus();
    }
  }



toggleCategoryVisibility = (categoryIndex) => {
  this.setState((prevState) => ({
    expandedCategories: {
      ...prevState.expandedCategories,
      [categoryIndex]: !prevState.expandedCategories[categoryIndex]
    }
  }));
};


jsoniconslist() {
  const categories = this.state.jsoniconslist;
  const data_status = this.state.data_status;
  const expandedCategories = this.state.expandedCategories;

  if (categories && data_status === 'success') {
    if (categories.length > 0) {
      let sno = 1;

      return categories.map((category, catIndex) => {
        const isExpanded = expandedCategories[catIndex] || false;
        const files = category.files;

        const allActive = files.every(file => file.status === 'A');
        const status = allActive ? 'active' : 'inactive';

        return (
          <tr key={catIndex}>
            <td>{sno++}</td>
            <td>{category.category_title}</td>
           <td style={{wordBreak: 'break-all'}}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                  {(isExpanded ? files : files.slice(0, 2)).map((f, fileIndex) => (
                    <a
                      href={`${mediaUrl}/faqjson/${f.json_file}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ marginLeft: '10px', textDecoration: 'none' }}
                      key={fileIndex}
                    >
                      <span>{f.json_file}</span>
                    </a>
                  ))}
                </div>
              {files.length > 2 && (
                <div style={{ marginTop: '5px' }}>
                  <Link
                    to="#"
                    onClick={() => this.toggleCategoryVisibility(catIndex)}
                    style={{ textDecoration: 'underline', cursor: 'pointer', fontWeight: 'bold' }}
                  >
                    {isExpanded ? 'Show Less' : 'Show More'}
                  </Link>
                </div>
              )}
          </td>
          <td>{moment(category.category_created_on).format('MMM DD Y hh:mm A')}</td>  
            <td>{files.length}</td>
             
            <td className="actiongroup">
              {status === 'active' ? (
                <Link onClick={() => this.confirmPopup(category.files[0].category_id, status,category.category_title)} title="Active">
                  <i className="ft-unlock" aria-hidden="true"></i>
                </Link>
              ) : (
                <Link onClick={() => this.confirmPopup(category.files[0].category_id, status,category.category_title)} title="In Active">
                  <i className="ft-lock" aria-hidden="true"></i>
                </Link>
              )}
              <Link to={{ pathname: '/json-view/' + category.files[0].category_id }} title="View">
                <i className="ft-eye" aria-hidden="true"></i>
              </Link>
               <Link to={{ pathname: '/json-edit/'+category.files[0].category_id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>


              {category.files[0].endpoints !== 'yes' && (
              <Link onClick={() => this.confirmPopup(category.files[0].category_id, 'delete', category.category_title)} className="" title="Delete">
                <i className="ft-trash-2" aria-hidden="true"></i>
              </Link>
            )}
               
            </td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="5" className="v-align-nr">No Result</td>
        </tr>
      );
    }
  } else {
    return (
      <tr>
        <td colSpan="5" className="v-align-nr">No Result</td>
      </tr>
    );
  }
}




listloadData(postobject=''){
  var qs = require('qs');
		
		
			let admin_id = localStorage.getItem("admin_id")
		
    if(postobject!=''){
      var postobject=postobject;
    }else{
      var postobject = {
        activePage: 1,
        search_all: '',
        admin_id: admin_id,
        };  
    }
        axios.post(apiUrl+"jsonaifeed/list",qs.stringify(postobject)).then(res => {
            console.log(res.data,'data')
            if(res.data.status === 'success'){	


              this.setState({  
                  jsoniconslist: res.data.categories, 
                  totalRecord: res.data.records_count, 
                  data_status: res.data.status,
                  total_files_count:res.data.total_files_count, 
                }, () => {
                  this.jsoniconslist();
                });
              // this.setState({  jsoniconslist: res.data.chaticonslist, totalRecord: res.data.records_count ,data_status: res.data.status}, function() {
              //    this.jsoniconslist();
              //   });
            } else {
               this.setState({  bt_data:[] ,jsoniconslist: [], totalRecord:''}, function() {
                this.jsoniconslist();
             });
            }
          }); 

}

handleNameClick = (id,name) => {
  this.setState({
    editMode: true,
    editedName: name,
    editItemId: id,
  });
};

handleNameChange = (e) => {
  this.setState({
    editedName: e.target.value,
  });
};

handleSaveName = (id) => {
  console.log(this.state.editedName,'nameedited')
  
  // const updatedInsurancelist = this.state.insurancelist.map((item) =>
  //   item.id === id ? { ...item, name: this.state.editedName } : item
  // );
  var admin_id = localStorage.getItem("admin_id");
  var postObject = {
    id  : id,
    admin_id  : admin_id,
    insurancename:  this.state.editedName,
  };
  var qs = require('qs');
  axios.post(apiUrl+"insurance/update", qs.stringify(postObject)).then(res => {
    if(res.data.status == "success"){
      $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
        this.listloadData();
    }else{
      $('.success_message').html('<div class="status_sucess"><h3>Something went wrong</h3></div>');
    }

    setTimeout(
      function() {
        $('.success_message').html('');
      }
      .bind(this),
      3000
    );
  });
  // Update state and exit edit mode
  this.setState({
    editMode: false,
    editedName: '',
  });
};
deletejsonfiles(){
  var qs = require('qs');
  var admin_id = localStorage.getItem("admin_id");
  var postObject = {
    id  : this.state.selectid,
    admin_id  : admin_id
  };
      axios.post(apiUrl+"jsonaifeed/delete__alljson",qs.stringify(postObject)).then(res => {
          if(res.data.status === 'success'){
                $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
                setTimeout(
                function() {
                $('.success_message').html('');
                }
                  .bind(this),
                3000
                );
                this.listloadData()
             
      }   
  
}); 

}
confirmPopup = (id, status,cat_title) => {
  var status = status;
  if(status == 'inactive'){
    status = "Active";
  }else if(status == 'active'){
    status = "Inactive";
  }else{
    status="Delete";
  }
  console.log(status,'this is confirmpopup',id)
 
  this.setState({selectid: id, selectedStatus: status,cat_title:cat_title})	
  $('.confirm-action').addClass('show');		
}

toggleCategoryVisibility = (categoryIndex) => {
  this.setState((prevState) => ({
    expandedCategories: {
      ...prevState.expandedCategories,
      [categoryIndex]: !prevState.expandedCategories[categoryIndex]
    }
  }));
};





jsoniconslistold() {
  var jsoniconslist = this.state.jsoniconslist;
  
  var data_status = this.state.data_status;

  if (jsoniconslist !== undefined && jsoniconslist !== null) {
    if (data_status === 'success') {
      if (Object.keys(jsoniconslist).length > 0) {
        const userlistDetails = jsoniconslist?.map((jsoniconslist, Index) => {
          
          let sno = Index + 1;
          if (jsoniconslist.status === 'A') {
            var status = 'active';
          } else {
            status = 'inactive';
          }

          return (
            <tr key={jsoniconslist.id}>
              <td>{sno}</td>
              <td>{jsoniconslist.json_title}</td>
              <td>
                 <a
                    href={`${mediaUrl}/faqjson/${jsoniconslist.json_file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      marginLeft: '8px',
                      color: '#007bff',
                      textDecoration: 'none',
                      fontSize: '19px'
                    }}
                  >
                    {jsoniconslist.json_file}
                  </a>
              </td>
              <td>{status}</td>
              <td className="actiongroup">
                {status === 'active' ? (
                  <Link onClick={this.confirmPopup.bind(this, jsoniconslist.category_id, status)} className="" title="Status">
                    <i className="ft-unlock" aria-hidden="true"></i>
                  </Link>
                ) : (
                  <Link onClick={this.confirmPopup.bind(this, jsoniconslist.id, status)} className="" title="Status">
                    <i className="ft-lock" aria-hidden="true"></i>
                  </Link>
                )}
                 {/* <Link to={{ pathname: '/chat-edit/'+jsoniconslist.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                 <Link onClick={this.confirmPopup.bind(this,jsoniconslist.id,'delete')} className="" title="Delete"><i className="ft-trash-2" aria-hidden="true"></i></Link> */}
                    
              </td>
            </tr>
          );
        });
        return userlistDetails;
      } else {
        return (
          <tr>
            <td colSpan="9" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    } else {
      return (
        <tr>
          <td colSpan="9" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  } else {
    return (
      <tr>
        <td colSpan="11" className="v-align-nr">
          No Result
        </td>
      </tr>
    );
  }
}
 
  handlePageChange(pageNumber) {
    this.setState({activePage: pageNumber});
    var qs = require('qs');
    var postobject = {
      activePage: pageNumber,
      search_all: this.state.search_all,
      admin_id: localStorage.getItem('admin_id')  
    };
   this.listloadData(postobject)
  }

  handleInputChange(event) {
  const {name, value} = event.target;  
 
  const postObject = {
    activePage: value ? 1 : this.state.activePage,  
    ...(value && { search_all: value }),  
    admin_id: localStorage.getItem('admin_id')
  };  
  this.setState({
    [name]: value
  },function(){
    this.listloadData(postObject)
  });
    

}
 handleFormSubmit = () => {
      
        this.setState({Loading:true});
        var qs = require('qs');
        const formPayload = this.state;
         
        var postObject = {             
          activePage   : this.state.activePage,
          search_all : this.state.search_all,
          admin_id: localStorage.getItem('admin_id')           
        };
        this.listloadData(postObject)
      
  } 

   componentWillReceiveProps(Props){
   }

activateinsurancelist(){
  
	let stat = ''
		if(this.state.selectedStatus ==='Inactive'){
			stat = "I";
		}else{
			stat = "A";
		}  

        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  : this.state.selectid,
		      status: stat
        };
      axios.post(apiUrl+"jsonaifeed/changestatus", qs.stringify(postObject)).then(res => {
        if(res.data.status == "success"){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
           this.listloadData()
           setTimeout(
            function() {
              $('.success_message').html('');
            }
            .bind(this),
            3000
            );
        }else{
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
        }
      });
}

Confirmstatus = (confirmstatus) => {
  if(confirmstatus == 'yes'){
    if(this.state.selectedStatus=="Delete"){
      this.deletejsonfiles()
    }else{
      this.activateinsurancelist();
    }
    
    $('.confirm-action').removeClass('show');
  }else{
    $('.confirm-action').removeClass('show');	
  }
    
}
exportdata(){
	let stat = '';		
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id")
        };
        axios.post(apiUrl+"user/export",qs.stringify(postObject)).then(res => {      
          if(res.data.status === 'success'){
            var url = res.data.url;
            var cleanurl = url.replace(/([^:]\/)\/+/g, "$1");
            window.open(cleanurl, '_blank', 'noreferrer');
            // window.location.reload();
          }
        }); 
      
}

  
  render()  {
    const datas = this.state.bt_data;
   
		const columns = [
			{dataField: 'id', text: 'ID', hidden: true}, 
			{dataField: 'sno', text: 'S.No', editable: false}, 
			{ dataField: 'name', text: 'Name', editorRenderer: (editorProps, value, row, column, rowIndex, columnIndex, columnIndexInHeaders) => {
        return (
          <input
            {...editorProps}
            value={value}
            onChange={(e) => {
              const updatedData = [...datas];
              updatedData[rowIndex][column.dataField] = e.target.value;
              this.setState({ bt_data: updatedData });
            }}
          />
        );
      } },
			{dataField: 'status', text: 'Status', editable: false},
			{dataField: 'action', text: 'Actions', editable: false}
		];

		let mystyle = {
		    color: "white",
		    backgroundColor: "#000000",
		    padding: "10px",		  
			minWidth: "49px",
			height: "37px",
			lineHeight: "0px",
			textTransform: "capitalize"
	
		};

    return (
      <div className="wrapper"> 
    <div className="confirm-action">
			<p>Are you sure you want to {this.state.selectedStatus} all files in "{this.state.cat_title}"?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
    <Header />
    <MenuSidebar currentpage="json" />  
  <div className="content"> 
    <div className="content-wrapper">
    <div class="content-wrapper-before"></div>
    <div className="car-listing-wrap leaa-admin-head card">
    <div className="success_message"></div>
        <div className="listing-header"> 
          <div className="title">

            <h3>{this.state.totalRecord > 0?this.state.totalRecord:''} Instant Chat Agent (AI) {this.state.totalRecord>1 ? '' : ''} </h3> 
            {/* {this.state.total_files_count} Files */}
          </div>
            <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
          </form>
                </div>
          <div className="add_button">  
      		 <a className="" href='/json-add'>Add &nbsp;&nbsp;</a>
           
          </div>
        </div>

        <div className="car-listing-row">
          
        <Table striped bordered hover>
            <thead>
              <tr>
                <th width="80">S.No</th>
                <th width='280'>Category Title</th>
                <th width='400'>JSON Files</th>
                <th width='300'>Created On</th>
                <th width='100'>JSON File Count</th>
                <th width='130'>Action</th>
              </tr>
            </thead>
            <tbody>{this.jsoniconslist()}</tbody>
          </Table>
            <div className="text-center">
              <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={10}
              totalItemsCount={this.state.totalRecord}
              pageRangeDisplayed={5}
              onChange={this.handlePageChange.bind(this)}
              />
            </div>
        </div>
                      
      </div>  
    </div>  
  </div>
    
    </div>
    );
  }
}

export default List;